/**
 * Permission name constants, mirroring the backend's permission definitions.
 *
 * Keep these strings in sync with the backend source of truth
 * (e.g. backend/app/pending_tasks/pending_tasks_permissions.py).
 */

export const VIEW_PENDING_TASKS_INVESTORS = 'view:pending_tasks_investors';
export const VIEW_PENDING_TASKS_PORTFOLIO = 'view:pending_tasks_portfolio';

export const VIEW_FUND_MEMBERS = 'view:fund_members';
export const MANAGE_FUND_MEMBERS = 'manage:fund_members';

export const EXPORT_INVESTORS = 'export:investors';

export const MANAGE_PORTFOLIO = 'manage:portfolio';
